<template>
  <div>
    <CompanyCard
      v-for="company in companies"
      :key="company.key"
      :company
      @save="(changes) => saveCompany(company.key, changes)"
      @add-meter="openForm(company, null)"
      @edit-meter="(meter) => openForm(company, meter)"
    />
    <ConsumptionLocationModal
      v-if="form"
      :init="form"
      @save="onSave"
      @remove="onRemove"
      @close="form = null"
    />
  </div>
</template>

<script setup lang="ts">
import type { CompanyEdit } from "@/compliance_groups/fixture/complianceGroupsTypes";
import type {
  CompanyView,
  DerivedDomain,
  MeterRowView,
} from "@/compliance_groups/fixture/derive";
import { deriveCompanies } from "@/compliance_groups/fixture/derive";
import {
  useComplianceDemoStore,
  type LocationFormSubmit,
  type LocationRef,
} from "@/compliance_groups/useComplianceDemoStore";
import { computed, ref } from "vue";
import CompanyCard from "./CompanyCard.vue";
import ConsumptionLocationModal, {
  type LocationFormInit,
} from "./ConsumptionLocationModal.vue";

const props = defineProps<{ domain: DerivedDomain }>();

const store = useComplianceDemoStore();
const companies = computed(() => deriveCompanies(props.domain, store.state));
const form = ref<LocationFormInit | null>(null);

const saveCompany = (companyKey: string, changes: CompanyEdit) => {
  for (const [field, value] of Object.entries(changes)) {
    if (value !== undefined)
      store.setCompanyField(
        props.domain.key,
        companyKey,
        field as keyof CompanyEdit,
        value
      );
  }
};

const openForm = (company: CompanyView, meter: MeterRowView | null) => {
  form.value = {
    isNew: meter === null,
    added: meter?.added ?? true,
    id: meter?.key ?? "",
    companyName: company.key,
    countryName: props.domain.name,
    cadence: props.domain.cadence,
    supplierRequired: props.domain.supplierRequired,
    name: meter?.name ?? "",
    mpid: meter?.mpid ?? "",
    supplier: meter?.supplier ?? "",
    months: meter ? [...meter.months] : Array(12).fill(0),
  };
};
const onSave = (submit: LocationFormSubmit) => {
  store.saveLocation(props.domain.key, submit);
  form.value = null;
};
const onRemove = (ref: LocationRef) => {
  store.removeLocation(props.domain.key, ref);
  form.value = null;
};
</script>
